

import React from 'react'
import UserListTable from './Components/UserListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import {HeadingOne} from "Common/Custom/HeadingOne";

const UserList = () => {
  return (
    <PageBody
     card={true}
     headerchildren={
        <>
        <HeadingOne>User List</HeadingOne>
        <AddItemBtn url="user-add" title="Create User"/>
        </>
       }>

      {/* Table section */}
      <div className="col-12">
        <UserListTable />
      </div>
    </PageBody>
  );
};

export default UserList;
